import service from '@/store/services/employers/institutions-service';

const state = {
    list: {},
    institution: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, institution) => {
        state.institution = institution;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(institution => {
                commit('SET_RESOURCE', institution);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(institution => {
                commit('SET_RESOURCE', institution);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((institution) => {
                commit('SET_RESOURCE', institution);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((institution) => {
                commit('SET_RESOURCE', institution);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    institution: state => state.institution,
    dropdown: (state) => {
        return state.list.map(institution => ({
            id: institution.id,
            name: institution.name,
            description: institution.description,
            address: institution.address,
            phone_number: institution.phone_number,
            telephone_number: institution.telephone_number,
            email:institution.email,
            website: institution.website,
            logo: institution.logo,
            business_name: institution.business_name,
        }));
    }
};

const institutions = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default institutions;
